import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { ACTIVE_EVENTS_REPORT_ID } from './activeEventsReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.EVENT_NAME.field,
        FIELDS.LAST_DATE_RECEIVED.field,
        FIELDS.TOTAL_RECEIVED.field,
        FIELDS.DEFINED_CONVERSIONS.field,
    ].map(field => generateColumnId(ACTIVE_EVENTS_REPORT_ID, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.EVENT_NAME.field,
    FIELDS.LAST_DATE_RECEIVED.field,
    FIELDS.TOTAL_RECEIVED.field,
    FIELDS.DEFINED_CONVERSIONS.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(ACTIVE_EVENTS_REPORT_ID, field));

export { customColumns, defaultColumns };
